<template>
  <div class="connect-dialog">
    <el-popover
      placement="left"
      trigger="hover"
      width="360"
      popper-class="connect-popover"
      :visible-arrow="true"
      @show="popoverVisible = true"
      @hide="popoverVisible = false"
    >
      <div class="connect-panel">
        <div class="connect-phone-row">
          <img class="connect-icon" :src="telIcon" alt="" />
          <span class="connect-label">咨询电话：</span>
          <span class="connect-value">4008-600797拨1</span>
        </div>
        <div class="connect-phone-row" style="margin-bottom: 30px">
          <img class="connect-icon" :src="phoneIcon" alt="" />
          <span class="connect-label">市场电话：</span>
          <span class="connect-value">15258875611</span>
        </div>
        <div class="connect-qr-row">
          <div class="connect-qr-item">
            <img class="connect-qr-img" :src="codeWx" alt="联系在线客服" />
            <p class="connect-qr-caption">联系在线客服</p>
          </div>
          <div class="connect-qr-item">
            <img class="connect-qr-img" :src="codeDy" alt="添加企业微信" />
            <p class="connect-qr-caption">添加企业微信</p>
          </div>
        </div>
      </div>
      <p
        slot="reference"
        class="connect-dialog-bt"
        :class="{ active: popoverVisible }"
        role="button"
        tabindex="0"
      />
    </el-popover>
  </div>
</template>

<script>
import telIcon from "@/assets/images/tel.png";
import phoneIcon from "@/assets/images/phone.png";
import codeWx from "@/assets/images/code-wx.png";
import codeDy from "@/assets/images/code-dy.png";
import connectIdle from "@/assets/images/connect1.png";
import connectActive from "@/assets/images/connect2.png";

export default {
  name: "ConnectDialog",
  data() {
    return {
      popoverVisible: false,
      telIcon,
      phoneIcon,
      codeWx,
      codeDy,
      connectIdle,
      connectActive,
    };
  },
};
</script>

<style lang="less">
.connect-dialog {
  position: fixed;
  bottom: 60px;
  right: 30px;
  width: 78px;
  height: 213px;
  z-index: 1000;

  .connect-dialog-bt {
    width: 100%;
    height: 100%;
    margin: 0;
    cursor: pointer;
    background-size: 78px 213px;
    background-repeat: no-repeat;
    background-position: center 0;
    background-image: url("@/assets/images/connect1.png");
    &.active {
      background-image: url("@/assets/images/connect2.png");
    }
  }
}

.connect-popover {
  padding: 24px !important;
  top: inherit !important;
  bottom: 20px !important;
}

.connect-panel {
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.connect-phone-row {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
  margin-bottom: 20px;
  font-size: 22px;
  line-height: 1.5;
  color: rgba(59, 57, 57, 1);

  &:last-of-type {
    margin-bottom: 32px;
  }
}

.connect-icon {
  display: inline-block;
  width: 16px;
  height: 16px;
  object-fit: contain;
}

.connect-qr-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.connect-qr-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 0;
}

.connect-qr-img {
  display: inline-block;
  width: 100px;
  height: 100px;
  object-fit: contain;
}

.connect-qr-caption {
  margin: 5px 0 0;
  font-size: 16px;
  line-height: 1.4;
  color: rgba(104, 104, 104, 1);
  text-align: center;
}
</style>
